export var Route;
(function (Route) {
    Route["AnomalyEvents"] = "/anomalies/:anomalyId/anomaly-events";
    Route["Anomalies"] = "/anomalies";
    Route["Anomaly"] = "/anomalies/:anomalyId";
    Route["Interactions"] = "/interactions";
    Route["Languages"] = "/languages";
    Route["Model"] = "/models/:modelId";
    Route["Tags"] = "/tags";
    Route["TimeZones"] = "/time-zones";
    Route["Tokens"] = "/tokens";
    Route["TokensRefresh"] = "/tokens/refresh";
    Route["UsersMe"] = "/users/me";
})(Route || (Route = {}));
//# sourceMappingURL=route.js.map